import { ReplyAll } from "@mui/icons-material";
import {
  Box,
  Modal,
  Stack,
  Typography,
  Button,
  Paper,
  TextField,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import api from "../../../services/api";
import { useMapa } from "../../../contexts/mapaContext";

const ModalAcknowledge = ({ open, onClose, alertData }) => {
  const theme = useTheme();
  const { setSnackbar = () => {}, updateDataElementSocket = () => {} } =
    useMapa();
  const [load, setLoad] = useState(false);
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setLoad(false);
    setMessage("");
    onClose();
  };

  const handleUpdateAcknowledge = async () => {
    setLoad(true);
    //pega dados do usuario logado
    const user = JSON.parse(localStorage.getItem("perfil"));
    const userEmail = user?.name || user?.nomeFantasia || "Desconhecido";
    const userId = user?.usuarioClienteId || "Desconhecido";
    try {
      const response = await api.post("/easyMaps/zabbix/setAcknowledgeEvent", {
        eventid: alertData?.eventid,
        message:
          message +
          `\n--------------------\nReconhecido via Sistema Web por: ${userEmail} (userId: ${userId})`,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Alerta reconhecido com sucesso!",
          severity: "success",
        });
        updateDataElementSocket();
        onClose();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setLoad(false);
    }
  };

  const styles = {
    modalContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "650px",
      maxWidth: "90%",
      p: 1,
    },
    innerBox: {
      p: 2,
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: 1,
    },
    icon: {
      color: theme.palette.primary.main,
    },
    description: {
      mt: 2,
      color: theme.palette.text.secondary,
    },

    actions: {
      mt: 2,
    },
    confirmButton: {
      color: theme.palette.text.primary,
    },
    textField: {
      marginTop: 2,
      "& .MuiOutlinedInput-root": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
        boxShadow: "none",
        "&:hover": {
          backgroundColor: theme.palette.background.paperLinkedMaps,
        },
      },
    },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={styles.modalContainer}
    >
      <Paper sx={styles.paper}>
        <Box sx={styles.innerBox}>
          <Box sx={styles.header}>
            <ReplyAll sx={styles.icon} />
            <Typography id="modal-title" variant="h6" component="h2">
              Reconhecer Alerta
            </Typography>
          </Box>

          <Typography id="modal-description" sx={styles.description}>
            Você está prestes a reconhecer o alerta:{" "}
            <strong>{alertData?.description}</strong>. Se desejar, adicione um
            comentário abaixo.
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Adicionar um comentário (opcional)"
            sx={styles.textField}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={styles.actions}
          >
            <Button
              disabled={load}
              variant="text"
              color="primary"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              disabled={load}
              variant="text"
              sx={styles.confirmButton}
              onClick={handleUpdateAcknowledge}
            >
              Reconhecer
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Modal>
  );
};

export default ModalAcknowledge;
